import { initializeApp } from 'firebase/app';
import { reCAPTCHAKey, firebaseConfig } from 'config';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import Functions from './functions';
import Firestore from './firestore';
import Storage from './storage';

const app = initializeApp(firebaseConfig);

// eslint-disable-next-line no-restricted-globals
self.FIREBASE_APPCHECK_DEBUG_TOKEN =
  process.env.REACT_APP_CHECK_DEBUG_TOKEN_FROM_CI;

console.log(process.env.REACT_APP_CHECK_DEBUG_TOKEN_FROM_CI);

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(reCAPTCHAKey),
  // Optional argument. If true, the SDK automatically refreshes App Check
  // tokens as needed.
  isTokenAutoRefreshEnabled: true,
});

const getCurrentUserUid = () => getAuth(app).currentUser?.uid;

const helpers = {
  getCurrentUserUid,
};

const functions = new Functions(app);
const firestore = new Firestore(app, helpers);
const storage = new Storage(app, helpers);

export default app;
export { functions, firestore, storage, getCurrentUserUid };
export * from './errorMessages';
